"use client"

/**
 * Velova marketing nav — v2 pages (/actions, /pricing, /contact).
 *
 * This used to be a separate sticky "pill" nav with its own geometry, its own
 * link colours and its own hand-drawn wordmark. That is exactly why the header
 * appeared to move, recolour and change logo when navigating between the
 * homepage and a v2 page.
 *
 * There is now ONE header for the whole marketing site. This module re-exports
 * it so the v2 pages keep their existing `<VelovaNav />` import while rendering
 * the identical component, in the identical position, as every other page.
 *
 * The scoped v2 stylesheet is still imported here because the v2 pages depend
 * on it for the rest of their design system (.vx-root, buttons, footer links).
 */

import { SiteHeader } from "@/components/landing/site-header"
import "./velova-site.css"

export function VelovaNav() {
  return <SiteHeader />
}
